import { Component } from '@angular/core';

@Component({
  selector: 'app-token-sale-page',
  templateUrl: './token-sale-page.component.html',
  styleUrls: ['./token-sale-page.component.scss']
})
export class TokenSalePageComponent {}
